import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ShortTestimonials } from './components/ShortTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { TomosSlider } from './components/TomosSlider';
import { BonusSlider } from './components/BonusSlider';
import { PricingSection } from './components/PricingSection';
import { FutbolTacticoPro } from './components/FutbolTacticoPro';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalComparisonTable } from './components/FinalComparisonTable';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n = (f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    }) as any;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1904779843432668');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-dark overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ShortTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductOverview data-id="element-4" />
      <TomosSlider data-id="element-5" />
      <BonusSlider data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FutbolTacticoPro data-id="element-8" />
      <ExtendedTestimonials data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <FinalComparisonTable data-id="element-12" />
      <FinalCta data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}